import { api } from "./http-client";
import { API_PATHS } from "../config/api.config";

export const systemService = {
  /** Configured by an admin in the CMS; null until one has been set. */
  getSupportEmail: async (): Promise<string | null> =>
    (
      await api.request<{ supportEmail: string | null }>({
        url: API_PATHS.SYSTEM.CONTACT,
        method: "GET",
      })
    ).data.supportEmail,
};
